import { useBreakpoint } from '@shared/hooks/use-page-size';
import { cn } from '@shared/lib/utils';
import { cloneElement, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { Element } from 'react-scroll';
import { ReportSection, ReportType } from '../types';
import ReportLayoutTitle from './report-layout-title';

export function ReportPage({
  item,
  setActive,
  containerId,
  downloadMode,
  reportType,
}: {
  item: ReportSection;
  setActive: React.Dispatch<React.SetStateAction<string>>;
  containerId: string;
  downloadMode?: boolean;
  reportType: ReportType;
}) {
  const { title, preTitle, url, link } = item;
  const screen = useBreakpoint();
  const { ref, inView } = useInView({
    threshold: 0.3,
  });

  useEffect(() => {
    if (inView && (screen === 'lg' || screen === 'xl')) {
      window.location.hash = url;
      setActive(url);
    }
  }, [containerId, inView, screen, setActive, url]);

  return (
    <div
      ref={ref}
      className={cn(
        'w-full lg:h-[--content-title-height] min-h-[--content-title-height] overflow-hidden bg-gray-00'
      )}
    >
      <Element
        name={url}
        key={title}
        id={url}
        className="flex flex-col"
        data-testid={`report-section-${url.replace('#', '')}`}
      >
        <ReportLayoutTitle
          title={title}
          preTitle={preTitle}
          link={link}
          scrollContainerId={containerId}
          downloadMode={downloadMode}
          data-testid={`report-section-title-${url.replace('#', '')}`}
        />
        {item.component &&
          cloneElement(item.component, {
            downloadMode,
            reportType,
          })}
      </Element>
    </div>
  );
}
